import styled from "styled-components";
import { Flex, Avatar } from "antd";
import { SB_COLORS } from "theme/SbThemeV2";

export const TourMessageStyled = styled(Flex)`
  width: 320px;
  max-width: 100%;
  padding: 12px 16px;
  text-align: center;

  .ant-typography {
    margin: 0;
  }
`;

export const TourMessageIconStyled = styled(Avatar)`
  background: ${SB_COLORS.primary};
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 34px;
    height: 34px;
  }
  svg path {
    fill: #ffffff;
  }
`;

export const TourStepStyled = styled(Flex)`
  width: 280px;
  max-width: 100%;
  padding: 12px 12px 0;

  .ant-typography {
    margin: 0;
  }
`;
